interface Tab {
  key: string;
  title: string;
}

export const routes = [
  { key: 'top', title: 'Relevant' },
  { key: 'stake', title: 'Hot' },
  { key: 'new', title: 'New' },
  { key: 'spam', title: 'Spam' },
  { key: 'flagged', title: 'Flagged' },
];

export const getRoutes = (isAdmin: boolean): Tab[] => {
  if (isAdmin) return routes;
  const i = routes.findIndex((r) => r.key === 'flagged');
  return [...routes.slice(0, i), ...routes.slice(i + 1, 0)];
};

export function getDiscoverState(nextProps: any, prevState: any) {
  const { sort } = nextProps.match.params;
  if (sort && sort !== prevState.sort) {
    const tabIndex = prevState.routes.findIndex((tab: Tab) => tab.key === sort);
    return { tabIndex, routes, sort };
  }
  if (!sort) return { tabIndex: -1, routes, sort };
  return null;
}
